export const ALERT = 'ALERT'

export const COUNTER = 'COUNTER'

export const NEW_REQUESTS = 'NEW_REQUESTS'
export const REMOVE_NEW_REQUESTS = 'REMOVE_NEW_REQUESTS'
export const ONGOING_REQUESTS = 'ONGOING_REQUESTS'
export const REMOVE_ONGOING_REQUESTS = 'REMOVE_ONGOING_REQUESTS'
export const CONCLUDED_REQUESTS = 'CONCLUDED_REQUESTS'
export const REMOVE_CONCLUDED_REQUESTS = 'REMOVE_CONCLUDED_REQUESTS'

export const FETCH_ALL = 'FETCH_ALL'
export const NEW_QUOTES = 'NEW_QUOTES'
export const REMOVE_NEW_QUOTE = 'REMOVE_NEW_QUOTE'
export const PENDING_QUOTES = 'PENDING_QUOTES'
export const REMOVE_PENDING_QUOTE = 'REMOVE_PENDING_QUOTE'
export const UNASSIGNED_QUOTES = 'UNASSIGNED_QUOTES'
export const REMOVE_UNASSIGNED_QUOTES = 'REMOVE_UNASSIGNED_QUOTE'
export const URGENT_QUOTES = 'URGENT_QUOTES'
export const REMOVE_URGENT_QUOTES = 'REMOVE_URGENT_QUOTE'
export const APPROVED_QUOTES = 'APPROVED_QUOTES'
export const REMOVE_APPROVED_QUOTES = 'REMOVE_APPROVED_QUOTES'
export const COMPLETED_QUOTES = 'COMPLETED_QUOTES'
export const REMOVE_COMPLETED_QUOTES = 'REMOVE_COMPLETED_QUOTES'
export const INCOMPLETE_QUOTES = 'INCOMPLETE_QUOTES'
export const REMOVE_INCOMPLETE_QUOTES = 'REMOVE_INCOMPLETE_QUOTES'
export const UPDATE_INCOMPLETE_QUOTES = 'UPDATE_INCOMPLETE_QUOTES'
export const DECLINED_QUOTES = 'DECLINED_QUOTES'
export const REMOVE_DECLINED_QUOTES = 'REMOVE_DECLINED_QUOTES'
export const ONGOING_QUOTES = 'ONGOING_QUOTES'
export const CONCLUDED_QUOTES = 'CONCLUDED_QUOTES'
export const UPDATE_CONCLUDED_QUOTES ='UPDATE_CONCLUDED_QUOTES'
export const UPLOAD_QUOTE = 'UPLOAD_QUOTE'
export const RESET_QUOTE = 'RESET_QUOTE'

export const AUTH = 'AUTH'
export const LOGOUT = 'LOGOUT'
export const UNAPPROVED_TRANSLATORS = 'UNAPPROVED_TRANSLATORS'
export const REMOVE_UNAPPROVED_TRANSLATORS = 'REMOVE_UNAPPROVED_TRANSLATORS'

export const VAT = 7.5